import { RfhColors } from '../config/florimixColors'
import type { BusinessAssociation } from '../types/api'

export const businessAssociationColors = [
  RfhColors.dutchOrange,
  RfhColors.hydroGreen,
  RfhColors.leafGreen,
  RfhColors.royalPurple,
  RfhColors.yellow,
]

export const getInitials = (name: string): string => {
  const words = name
    .trim()
    .split(' ')
    .filter(word => word.length > 0)
  const firstWord = words[0]
  return firstWord?.slice(0, 2).toUpperCase() ?? ''
}

export const getBusinessAssociationRole = (
  role: string,
  language: string | undefined
): string => (role === 'Klant' && language === 'en' ? 'Customer' : role)

// The option to create a transaction for yourself, rather than for a fetched business association
export const createSelfBusinessAssociation = ({
  customerNumber,
  name,
  role,
}: {
  customerNumber: number
  name: string
  role: string
}): BusinessAssociation => ({
  id: customerNumber,
  name,
  role,
})
